import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import CredittentWrapper from "@components/layouts/creditTentWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function CredittentHome(): ReactElement {
    return (
        <CredittentWrapper>
            <PrivacyPolicy category="Credit Repair" domain="CreditRepair.com" />
        </CredittentWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
